<template>
    <!--<div class="animated fadeIn">
        <b-row>
            <b-col lg="12">
                <b-card>
                    <div slot="header">
                        <strong>Menu</strong>
                    </div>
                    <b-form @submit.prevent="search">
                        <b-row>
                            <b-col>
                                <b-form-group label="Tên menu:"
                                              label-for="name"
                                              :label-cols="4"
                                              :horizontal="true"
                                              label-align="right">
                                    <b-form-input type="text" id="name"
                                                  class="col-6"
                                                  placeholder="Nhập tên menu ..."
                                                  v-model="searchForm.filterText">
                                    </b-form-input>
                                </b-form-group>
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col>
                                <b-form-group label="" :label-cols="4">
                                    <b-button type="submit" variant="primary">Tìm kiếm</b-button>
                                </b-form-group>
                            </b-col>
                        </b-row>
                    </b-form>
                    <br />
                    <b-grid :searchForm="searchForm"
                            :gridOptions="gridOptions"
                            selectable
                            dataUrl="system/menus"
                            gridName="Danh sách menu"
                            ref="roleTable">
                        <template v-slot:actions>
                            <router-link to="/system/menus/create" tag="button" class="btn btn-primary" size="md">
                                Thêm mới
                            </router-link>
                            <b-button size="md" @click.stop="removeSelected" variant="danger">
                                Xóa
                            </b-button>
                        </template>
                        <template v-slot:cell(status)="row">
                            <b-form-checkbox v-model="row.value" @change="updateStatus(row.item, $event)"></b-form-checkbox>
                        </template>
                        <template v-slot:cell(_actions)="row">
                            <b-button-group>
                                <b-button size="sm" :to="{ path: `./${row.item.id}/detail` }" title="xem" variant="info">
                                    Xem
                                </b-button>
                                <template>
                                    <b-button size="sm" :to="{ path: `./${row.item.id}/edit` }" title="sửa" variant="primary">
                                        Sửa
                                    </b-button>
                                    <b-button size="sm" @click.stop="remove(row.item, row.index, $event.target)" class="mr-1" title="xóa" variant="danger">
                                        Xoá
                                    </b-button>
                                </template>
                            </b-button-group>
                        </template>
                    </b-grid>
                </b-card>
            </b-col>
        </b-row>
    </div>-->

    <b-col class="animated fadeIn">
        <b-row>
            <b-col lg="12">
                <b-card>
                    <div slot="header">
                        <strong>Danh sách Menu</strong>
                    </div>
                    <b-row>
                        <b-col md="5">
                            <!--<select2 style="width:100%" v-model="groupMenuSelected"
                                     v-if="groupMenus.length > 0"
                                     :options="groupMenus"
                                     allowClear="true"
                                     placeholder="--- Tất cả ---"></select2>-->
                        </b-col><!--v-if="authorize([])"-->
                        <b-col md="7">
                            <div class="pull-right">
                                <b-button v-if="authorize(['ManageMenu'])" tag="button" class="mr5" variant="info" size="md" :to="{ path: `/system/menus/create` }" title="xem">
                                    Thêm mới
                                </b-button>
                                <b-button v-if="authorize(['ManageMenu'])" size="md" tag="button" variant="primary"
                                          :disabled="!menuSelected"
                                          :to="{ path: `/system/menus/edit/${menuSelected}` }" title="sửa" class="mr5">
                                    Sửa
                                </b-button>
                                <b-button v-if="authorize(['ManageMenu'])" size="md" tag="button" variant="danger" @click.stop="remove(menuSelected)" :disabled="!menuSelected">
                                    Xóa
                                </b-button>
                                <!--<router-link to="/system/menus/create" tag="button" class="btn btn-primary" size="md">
                                    Thêm mới
                                </router-link>
                                <b-button size="md" @click.stop="removeSelected" variant="danger">
                                    Xóa
                                </b-button>-->
                            </div>
                        </b-col>

                    </b-row>
                    <br />
                    <b-form style="min-height: 425px; max-height: 800px">
                        <b-row>
                            <b-col md="5">
                                <treeselect v-model="menuSelected"
                                            placeholder="--- Chọn ---"
                                            :options="menus" :always-open="true" :max-height="390" />
                            </b-col>
                            <b-col md="7" class="border" style="min-height:425px">
                                <b-form-group>
                                    <label class="col-form-label font-weight-bold">Thông tin Menu</label>
                                    <b-row>
                                        <b-col md="6">
                                            <b-form-group label="Tên:"
                                                          label-for="code"
                                                          :label-cols="5"
                                                          label-align-md="right"
                                                          :horizontal="true">
                                                <label class="col-form-label">{{ menu.name }}</label>
                                            </b-form-group>
                                        </b-col>

                                        <b-col md="6">
                                            <b-form-group label="icon:"
                                                          label-for="name"
                                                          :label-cols="5"
                                                          label-align-md="right"
                                                          :horizontal="true">
                                                <label class="col-form-label">{{ menu.icon }}</label>

                                            </b-form-group>
                                        </b-col>
                                    </b-row>
                                    <b-row>
                                        <b-col md="6">
                                            <b-form-group label="Đường dẫn:"
                                                          label-for="location"
                                                          :label-cols="5"
                                                          label-align-md="right"
                                                          :horizontal="true">
                                                <label class="col-form-label">{{ menu.url }}</label>

                                            </b-form-group>
                                        </b-col>
                                        <b-col md="6">
                                            <b-form-group label="Vị trí hiển thị:"
                                                          label-for="address"
                                                          :label-cols="5"
                                                          label-align-md="right"
                                                          :horizontal="true">
                                                <label class="col-form-label">{{ menu.displayOrder }}</label>

                                            </b-form-group>
                                        </b-col>
                                    </b-row>
                                    <b-row>
                                        <!--<b-col md="6">
                                            <b-form-group label="Nhóm menu cha:"
                                                          label-for="phone"
                                                          :label-cols="5"
                                                          label-align-md="right"
                                                          :horizontal="true">
                                                <label class="col-form-label">{{ menu.groupMenuName }}</label>

                                            </b-form-group>
                                        </b-col>-->
                                        <b-col md="6">
                                            <b-form-group label="Menu cha:"
                                                          label-for="fax"
                                                          :label-cols="5"
                                                          label-align-md="right"
                                                          :horizontal="true">
                                                <label class="col-form-label">{{ menu.parentName }}</label>
                                            </b-form-group>
                                        </b-col>
                                    </b-row>
                                </b-form-group>
                            </b-col>
                        </b-row>
                    </b-form>
                </b-card>
            </b-col>
        </b-row>
    </b-col>
</template>
<script>
    import { authorizationMixin } from '@/shared/mixins'
    import { mapState } from 'vuex'

    export default {
        name: 'ListMenus',
        mixins: [authorizationMixin],
        data() {
            return {
                searchForm: {
                    filterText: null
                },
                menu: {},
                menuSelected: null,
                groupMenuSelected: null,
            }
        },
        created() {
        },
        computed: {
            menus() {
                return this.$store.getters.menuTree;
            }
        },
        watch: {
            menuSelected() {
                return this.loadMenuDetail();
            }
        },
        methods: {
            loadMenuDetail() {
                var vm = this;
                return this.$services.get(`system/menus/${this.menuSelected || ''}`).done(menu => {
                    vm.menu = menu;
                });
            },
            search() {
                this.$refs.roleTable.refresh();
            },
            remove(item, index, button) {
                var vm = this;
                if (confirm('Bạn có chắc chắn muốn xóa menu này?')) {
                    this.$services.delete(`system/menus/${this.menuSelected || ''}`).done(() => {
                        vm.$toastr.s('Xóa menu thành công');
                        vm.$store.dispatch('loadMenus').done(() => {
                            vm.search();
                        });
                    });
                }
            },
            updateStatus(user, checked) {
                var action = checked ? "khóa" : "mở khóa";
                if (confirm('Bạn có chắc muốn ' + action + ' tài khoản này?')) {
                    this.$services.put(`users/${user.id}/status`);
                } else {
                    this.$nextTick(() => user.isLocked = !checked);
                }
            }
        }
    }
</script>
<style scoped>
</style>
